import React from 'react';
interface SwitchProps {
  id:string,
  name:string,
  value:boolean
  onChange: React.ChangeEventHandler<HTMLInputElement> | undefined;
}
export default function SwitchButton({onChange, id, name, value}:SwitchProps) {
  return (
      <div>
          <input
          className="relative h-5 w-10 cursor-pointer appearance-none rounded-full bg-red-500 transition duration-300 
          checked:bg-primary-500 
          focus:outline-none focus:ring-2 focus:ring-blue-300 
          before:absolute before:top-0.5 before:left-0.5 before:h-4 before:w-4 before:rounded-full before:bg-white before:shadow-md 
          before:transition-transform before:duration-300 
          checked:before:translate-x-5"
              type="checkbox"
              role="switch"
              id={id} 
              name={name}
              checked={value}
              onChange={onChange}
              />
      </div>
  );
}